import { Card, CardContent, CardMedia, Skeleton } from '@mui/material';

export const PostThumbnail: React.FunctionComponent<{
  title: string;
  domain: string;
  url: string;
  websiteUrl: string;
}> = ({ title, domain, url, websiteUrl }) => {
  return (
    <Card
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        window.open(websiteUrl);
      }}
      sx={{
        borderRadius: '10px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
        margin: '10px 2px 10px 2px !important',
        height: 'auto !important',
        overflow: 'hidden !important',
        cursor: 'pointer',
      }}
    >
      <CardMedia sx={{ height: 123 }} image={url} title={title} />
      <CardContent className="!pb-4">
        <p className="text-sm text-[#A8A8A8] mb-2">{domain}</p>
        <p
          style={{ wordWrap: 'break-word' }}
          className="font-bold text-lg line-clamp-2"
        >
          {title}
        </p>
      </CardContent>
    </Card>
  );
};

export const PostThumbnailSkeleton = () => {
  return (
    <div className="mt-5">
      <Skeleton variant="rounded" width={'100%'} height={100} />
    </div>
  );
};
